import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { map } from 'lodash';
import uuid from 'uuid/v1';

import { getWMSLayerStyle } from '../../../api/Layers/layer-operations';

const LayerWMSStyleNamesField = ({ preselectedStyles, failedFetchDueToCORS, layer }) => (
  <Form.Group>
    <Form.Label>Layer Styles</Form.Label>
    {!failedFetchDueToCORS && (
      <Form.Control
        as="select"
        name="styleNameSelected"
        defaultValue={getWMSLayerStyle(layer)}
        placeholder="What's the code name for the styles?"
      >
        {map(preselectedStyles, (wmsStyle, index) => (
          <option key={uuid()} value={preselectedStyles[index]}>
            {wmsStyle}
          </option>
        ))}
      </Form.Control>
    )}
    {failedFetchDueToCORS && (
      <>
        <Form.Control
          type="text"
          name="styleNamesInput"
          defaultValue={getWMSLayerStyle(layer)}
          placeholder="What's the code name for the style?"
        />
        <Form.Text className="text-muted text-break">
          Enter the style name separated by commas, no spaces. Example:
          <br />
          TN.RailTransportNetwork.RailwayLink,TN.RoadTransportNetwork.RoadLink,TN.AirTransportNetwork.RunwayArea
        </Form.Text>
      </>
    )}
  </Form.Group>
);

LayerWMSStyleNamesField.propTypes = {
  layer: PropTypes.object.isRequired,
  preselectedStyles: PropTypes.array.isRequired,
  failedFetchDueToCORS: PropTypes.bool.isRequired
};

export default LayerWMSStyleNamesField;
